import { useEffect } from 'react';
import { analytics } from 'pages';

export function BottomCTA({ applyURL }: any) {
  return (
    <div className="px-10 pt-20 pb-28 text-center text-white bg-[#2B1C66] ">
      <div className="text-5xl font-bold text-white md:text-6xl">
        Ready to start?
      </div>
      <div className="pt-6 text-base text-gray-300">
        Apply today and get up to 6 months free
      </div>
      <div className="max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8">
        <div
          className="rounded-md"
          onClick={() =>
            analytics.track(`Marketing_For Startups_Apply Now Button Clicked`, {
              surface: 'Marketing',
              location: 'For Startups'
            })
          }
        >
          <a
            href={applyURL}
            target="_blank"
            rel="noopener"
            className="flex items-center justify-center w-full px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-clerk-blue md:py-4 md:text-lg md:px-10"
          >
            Apply now
          </a>
        </div>
      </div>
    </div>
  );
}
